import { AlertBanner } from '@apollo/orbit';
import React from 'react';

import { ClickableText } from 'src/components/common/clickableText/ClickableText';

export const ChecksDisabledAlertBanner = ({
  canQueryCheckConfiguration,
  description,
  bannerLink,
}: {
  canQueryCheckConfiguration: Boolean | undefined;
  description: React.ReactNode;
  bannerLink: JSX.Element;
}) => {
  return (
    <div className="mt-2 px-8">
      <AlertBanner status="warning" className="py-3">
        {description}
        {canQueryCheckConfiguration && (
          <ClickableText as={bannerLink} className="font-semibold underline">
            Configure
          </ClickableText>
        )}
      </AlertBanner>
    </div>
  );
};
